module.exports = __webpack_public_path__ + "img/1.8d5a50c6.png";